import { SVGFC } from '@repo/toolkit/types'

const WalkingPersonIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.0463 12.4759L14.1646 12.8494C14.3251 12.9146 14.5042 12.9173 14.6666 12.857C14.829 12.7967 14.9629 12.6777 15.0419 12.5236C15.121 12.3694 15.1394 12.1912 15.0936 12.0242C15.0479 11.8571 14.9412 11.7132 14.7946 11.6209L13.1127 10.6894L12.0625 9.06885"
        stroke={color}
        strokeWidth="0.5625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8532 7.49104C11.7818 7.49104 12.5345 6.73829 12.5345 5.80973C12.5345 4.88117 11.7818 4.12842 10.8532 4.12842C9.92462 4.12842 9.17188 4.88117 9.17188 5.80973C9.17188 6.73829 9.92462 7.49104 10.8532 7.49104Z"
        stroke={color}
        strokeWidth="0.5625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9225 14.4028L8.80325 15.8164L6.7715 18.6795C6.65118 18.8207 6.5895 19.0026 6.59912 19.1878C6.60874 19.3731 6.68893 19.5476 6.82322 19.6755C6.95751 19.8035 7.1357 19.8751 7.32118 19.8758C7.50667 19.8765 7.68536 19.8061 7.82056 19.6791L9.86468 17.3335C10.1263 17.0334 10.3252 16.6839 10.4497 16.3058L10.853 15.0261"
        stroke={color}
        strokeWidth="0.5625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3177 8.0625H10.6057C11.4669 8.0625 12.165 8.76 12.165 9.62175V12.4005C12.165 12.7537 12.3056 13.0924 12.5554 13.3427L13.6314 14.4187C14.016 14.8034 14.2839 15.2889 14.4043 15.8194L15.1266 19.0009C15.143 19.1091 15.1359 19.2196 15.1057 19.3248C15.0755 19.43 15.0229 19.5275 14.9515 19.6105C14.8801 19.6935 14.7917 19.7601 14.6922 19.8058C14.5927 19.8514 14.4845 19.875 14.3751 19.875C14.2086 19.8751 14.0468 19.8205 13.9144 19.7197C13.782 19.6189 13.6863 19.4774 13.6421 19.317L12.5346 16.2806L9.75356 14.0036C9.53398 13.8238 9.3591 13.5955 9.24266 13.3366C9.12622 13.0778 9.07139 12.7955 9.08249 12.5119L9.16518 10.3778L8.17293 11.1804L7.84162 12.8533C7.82315 12.9468 7.78638 13.0357 7.73343 13.1149C7.68049 13.1941 7.6124 13.262 7.5331 13.3148C7.4538 13.3676 7.36484 13.4042 7.27135 13.4225C7.17785 13.4408 7.08166 13.4404 6.98831 13.4214C6.80593 13.3842 6.64496 13.278 6.53891 13.125C6.43287 12.972 6.38994 12.784 6.41906 12.6002L6.72281 10.6821C6.7917 10.2464 7.02882 9.85516 7.38318 9.5925L8.75006 8.58C9.20361 8.24387 9.75321 8.06244 10.3177 8.0625Z"
        stroke={color}
        strokeWidth="0.5625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_18125_222219)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 4.625C15.6883 4.625 14.625 5.68832 14.625 7C14.625 8.31168 15.6883 9.375 17 9.375C18.3117 9.375 19.375 8.31168 19.375 7C19.375 5.68832 18.3117 4.625 17 4.625ZM14.375 7C14.375 5.55025 15.5503 4.375 17 4.375C18.4497 4.375 19.625 5.55025 19.625 7C19.625 8.44975 18.4497 9.625 17 9.625C15.5503 9.625 14.375 8.44975 14.375 7Z"
          fill={color}
          stroke={color}
          strokeWidth="0.36"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 5.125C16.931 5.125 16.875 5.18096 16.875 5.25V7C16.875 7.06903 16.931 7.125 17 7.125C17.069 7.125 17.125 7.06903 17.125 7V5.25C17.125 5.18096 17.069 5.125 17 5.125Z"
          fill={color}
          stroke={color}
          strokeWidth="0.36"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6382 6.31913C15.6073 6.38087 15.6324 6.45596 15.6941 6.48683L16.9441 7.11183C17.0059 7.1427 17.0809 7.11768 17.1118 7.05593C17.1427 6.99418 17.1177 6.9191 17.0559 6.88823L15.8059 6.26322C15.7442 6.23235 15.6691 6.25738 15.6382 6.31913Z"
          fill={color}
          stroke={color}
          strokeWidth="0.36"
        />
      </g>
      <defs>
        <clipPath id="clip0_18125_222219">
          <rect width="6" height="6" fill={color} transform="translate(14 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WalkingPersonIcon
